export const GET_FEATURE_DEFINITIONS = 'GET_FEATURE_DEFINITIONS'
export const GET_FEATURE_DEFINITIONS_SUCCESS = 'GET_FEATURE_DEFINITIONS_SUCCESS'
export const GET_FEATURE_DEFINITIONS_FAIL = 'GET_FEATURE_DEFINITIONS_FAIL'

export const GET_FEATURE_STATUS = 'GET_FEATURE_STATUS'
export const GET_FEATURE_STATUS_SUCCESS = 'GET_FEATURE_STATUS_SUCCESS'
export const GET_FEATURE_STATUS_FAIL = 'GET_FEATURE_STATUS_FAIL'

export const GRANT_TRIAL_FEATURE = 'GRANT_TRIAL_FEATURE'
export const GRANT_TRIAL_FEATURE_SUCCESS = 'GRANT_TRIAL_FEATURE_SUCCESS'
export const GRANT_TRIAL_FEATURE_FAIL = 'GRANT_TRIAL_FEATURE_FAIL'

export const REVOKE_TRIAL_FEATURE = 'REVOKE_TRIAL_FEATURE'
export const REVOKE_TRIAL_FEATURE_SUCCESS = 'REVOKE_TRIAL_FEATURE_SUCCESS'
export const REVOKE_TRIAL_FEATURE_FAIL = 'REVOKE_TRIAL_FEATURE_FAIL'

export const GET_ORGANISATION_DETAILS = 'GET_ORGANISATION_DETAILS'
export const GET_ORGANISATION_DETAILS_SUCCESS = 'GET_ORGANISATION_DETAILS_SUCCESS'
export const GET_ORGANISATION_DETAILS_FAIL = 'GET_ORGANISATION_DETAILS_FAIL'

export const CLEAR_FEATURE_ERROR = 'CLEAR_FEATURE_ERROR'

export const defaultOrganisationDetailState = {
  featureDefinitions: [],
  featureStatuses: {},
  loading: false,
  grantingFeature: false,
  error: null,
  errorMessage: null
}

export default (state = defaultOrganisationDetailState, action) => {
  let newState
  switch (action.type) {
    case GET_FEATURE_DEFINITIONS:
      newState = {
        ...state,
        loading: true,
        error: false,
        errorMessage: null
      }
      return newState

    case GET_FEATURE_DEFINITIONS_SUCCESS:

      let definitions = []
      // axios response structure: action.payload.data contains the response body
      const responseData = action.payload.data

      // Check if response has a data array (API returns { data: [...] })
      if (responseData && responseData.data && Array.isArray(responseData.data)) {
        definitions = responseData.data
      } else if (Array.isArray(responseData)) {
        definitions = responseData
      }

      newState = {
        ...state,
        featureDefinitions: definitions,
        loading: false,
        error: false,
        errorMessage: null
      }
      return newState

    case GET_FEATURE_DEFINITIONS_FAIL:
      newState = {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.error?.message || 'Failed to load feature definitions'
      }
      return newState

    case GET_FEATURE_STATUS:
      newState = {
        ...state,
        loading: true,
        error: false,
        errorMessage: null
      }
      return newState

    case GET_FEATURE_STATUS_SUCCESS: {
      const statusMap = {}
      const responseData = action.payload.data

      // Check if response has a data array
      let dataArray = []
      if (responseData && responseData.data && Array.isArray(responseData.data)) {
        dataArray = responseData.data
      } else if (Array.isArray(responseData)) {
        dataArray = responseData
      }

      if (dataArray && Array.isArray(dataArray)) {
        dataArray.forEach(feature => {
          statusMap[feature.featureName] = feature
        })
      }
      newState = {
        ...state,
        featureStatuses: statusMap,
        loading: false,
        error: false,
        errorMessage: null
      }
      return newState
    }

    case GET_FEATURE_STATUS_FAIL:
      newState = {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.error?.message || 'Failed to load feature status'
      }
      return newState

    case GRANT_TRIAL_FEATURE:
      newState = {
        ...state,
        grantingFeature: true,
        error: false,
        errorMessage: null
      }
      return newState

    case GRANT_TRIAL_FEATURE_SUCCESS:
      newState = {
        ...state,
        grantingFeature: false,
        error: false,
        errorMessage: null
      }
      return newState

    case GRANT_TRIAL_FEATURE_FAIL:
      newState = {
        ...state,
        grantingFeature: false,
        error: true,
        errorMessage: action.error?.message || 'Failed to grant feature'
      }
      return newState

    case REVOKE_TRIAL_FEATURE:
      newState = {
        ...state,
        grantingFeature: true,
        error: false,
        errorMessage: null
      }
      return newState

    case REVOKE_TRIAL_FEATURE_SUCCESS:
      newState = {
        ...state,
        grantingFeature: false,
        error: false,
        errorMessage: null
      }
      return newState

    case REVOKE_TRIAL_FEATURE_FAIL:
      newState = {
        ...state,
        grantingFeature: false,
        error: true,
        errorMessage: action.error?.message || 'Failed to revoke feature'
      }
      return newState

    case GET_ORGANISATION_DETAILS:
      newState = {
        ...state,
        loading: true,
        error: false,
        errorMessage: null
      }
      return newState

    case GET_ORGANISATION_DETAILS_SUCCESS:
      newState = {
        ...state,
        organisationDetails: action.payload?.data || {},
        loading: false,
        error: false,
        errorMessage: null
      }
      return newState

    case GET_ORGANISATION_DETAILS_FAIL:
      newState = {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.error?.message || 'Failed to load organisation details'
      }
      return newState

    case CLEAR_FEATURE_ERROR:
      newState = {
        ...state,
        error: false,
        errorMessage: null
      }
      return newState

    default:
      return state
  }
}

